import { Component } from '@angular/core';
import { Modal } from 'bootstrap';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-locations-list',
	templateUrl: './locations-list.component.html',
	styleUrls: ['./locations-list.component.css'],
})
export class LocationsListComponent extends ListComponent {
	protected apiUrl = 'location';
	protected apiType = 'bag';
	protected itemsBeforeDataLoad = 2;

	tableRows = [
		{ id: 'name', name: 'Nazwa Lokalizacji' },
		{ id: 'code', name: 'Kod' },
		{ id: 'locationKind', name: 'Rodzaj lokalizacji' },
		{ id: 'parentLocation', name: 'Lokalizacja nadrzędna' },
	];

	locationsKinds: Array<any> = [
		{ value: 'CR', name: 'Państwo' },
		{ value: 'RG', name: 'Region' },
		{ value: 'CT', name: 'Miasto' },
	];

	parameters = {
		id: null,
		offset: null,
		search: null,
	};

	protected convertData(result) {
		return result.results.map((item) => {
			item.parentLocation = item.parentLocation === null ? '' : `${item.parentLocation.name}`;
			const kind = this.locationsKinds.find((findObj) => findObj.value === item.locationKind);
			item.locationKind = kind ? kind.name : '';
			return item;
		});
	}
}
